import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Flex, Modal, ModalOverlay, mode, Text, useColorMode, useDisclosure } from '@abb/uikit';
import { XClose } from '@abb/uikit/icons/solid/general';
import { useGetLoyaltyList, useLoyaltyCheck, useLoyaltyRegister } from 'hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaydaPointIcon } from 'shared-components/icons/FaydaPointIcon';
import { HowDoesItwork } from './how-does-it-work';
import { Main } from './main';
import { Terms } from './terms';
export const Point = (param)=>{
    let { loyaltyStatus } = param;
    var _data_customerBalanceInfo, _data_customerBalanceInfo1;
    const { t } = useTranslation('common');
    const { colorMode } = useColorMode();
    const { isOpen, onClose, onOpen } = useDisclosure();
    const [terms, setTerms] = useState({
        isOpen: false,
        checked: false
    });
    const [tooltip, setTooltip] = useState(false);
    const [howDoesItWork, setHowDoesItWork] = useState(false);
    const { data, mutate: getList } = useGetLoyaltyList();
    const { data: isShow, mutate: checkMutate } = useLoyaltyCheck((data === null || data === void 0 ? void 0 : data.isRegistered) ? !!(data === null || data === void 0 ? void 0 : (_data_customerBalanceInfo = data.customerBalanceInfo) === null || _data_customerBalanceInfo === void 0 ? void 0 : _data_customerBalanceInfo.activePoints) ? 'IB_POINT_TOOLTIP' : '' : 'IB_LOYALTY_INFO_POPUP');
    const closeModal = ()=>{
        setTerms({
            isOpen: false,
            checked: false
        });
        getList();
        checkMutate();
        onClose();
    };
    const { isRegister } = useLoyaltyRegister(closeModal);
    useEffect(()=>{
        if (data) {
            if (!(data === null || data === void 0 ? void 0 : data.isRegistered) && isShow && !(isShow === null || isShow === void 0 ? void 0 : isShow.isShown)) {
                setHowDoesItWork(false);
                onOpen();
            } else {
                setHowDoesItWork(true);
            }
            (data === null || data === void 0 ? void 0 : data.isRegistered) && !!isShow && setTooltip(!(isShow === null || isShow === void 0 ? void 0 : isShow.isShown));
        }
        if (isShow) {
            !(data === null || data === void 0 ? void 0 : data.isRegistered) && !(isShow === null || isShow === void 0 ? void 0 : isShow.isShown) && onOpen();
        }
    }, [
        data,
        isShow
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                borderRadius: "50px",
                flexDirection: "row",
                position: "relative",
                justifyContent: "space-between",
                alignItems: "center",
                onClick: ()=>!tooltip && onOpen(),
                w: "fit-content",
                cursor: "pointer",
                children: [
                    (data === null || data === void 0 ? void 0 : data.isRegistered) && /*#__PURE__*/ _jsxs(Text, {
                        fontWeight: 500,
                        children: [
                            data === null || data === void 0 ? void 0 : (_data_customerBalanceInfo1 = data.customerBalanceInfo) === null || _data_customerBalanceInfo1 === void 0 ? void 0 : _data_customerBalanceInfo1.activePoints,
                            "\xa0\xa0 "
                        ]
                    }),
                    /*#__PURE__*/ _jsx(FaydaPointIcon, {
                        size: "20px"
                    }),
                    tooltip && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                position: "absolute",
                                bottom: "-160px",
                                right: "-100px",
                                backgroundColor: mode('white', '#282829')({
                                    colorMode
                                }),
                                w: "260px",
                                h: "148px",
                                borderRadius: "12px",
                                p: 4,
                                zIndex: 1111,
                                children: /*#__PURE__*/ _jsxs(Box, {
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ _jsx(XClose, {
                                            cursor: "pointer",
                                            onClick: ()=>{
                                                checkMutate();
                                                setTooltip(false);
                                            },
                                            position: "absolute",
                                            right: 0,
                                            top: 0
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            fontWeight: 500,
                                            children: t('loyalty.fayda_balance')
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            mb: 4,
                                            fontSize: "14px",
                                            children: t('loyalty.track_cashback')
                                        }),
                                        /*#__PURE__*/ _jsx(Flex, {
                                            w: "100%",
                                            justifyContent: "flex-end",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                onClick: ()=>{
                                                    checkMutate();
                                                    setTooltip(false);
                                                },
                                                variant: "outline",
                                                children: t('loyalty.noted')
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                bottom: "-27px",
                                left: "17px",
                                position: "absolute",
                                w: "20px",
                                h: "20px",
                                backgroundColor: mode('white', '#282829')({
                                    colorMode
                                }),
                                transform: "rotate(45deg)"
                            })
                        ]
                    })
                ]
            }),
            tooltip && /*#__PURE__*/ _jsx(Box, {
                zIndex: 9,
                top: "0",
                left: 0,
                position: "fixed",
                bg: "blackAlpha.700",
                h: "100vh",
                w: "100vw"
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                scrollBehavior: "inside",
                isCentered: true,
                isOpen: isOpen,
                onClose: closeModal,
                children: [
                    /*#__PURE__*/ _jsx(ModalOverlay, {}),
                    terms.isOpen ? /*#__PURE__*/ _jsx(Terms, {
                        setTerms,
                        isRegister,
                        data: data === null || data === void 0 ? void 0 : data.popupWording
                    }) : howDoesItWork ? /*#__PURE__*/ _jsx(HowDoesItwork, {
                        terms,
                        setTerms,
                        data,
                        isRegister,
                        onClose,
                        loyaltyStatus
                    }) : /*#__PURE__*/ _jsx(Main, {
                        data: data === null || data === void 0 ? void 0 : data.popupWording,
                        terms,
                        setTerms,
                        setHowDoesItWork,
                        isRegister
                    })
                ]
            })
        ]
    });
};
